<template>
  <div class="inventory-next_page">
    <h3 class="title-page">{{ $t("realization") }}</h3>
    <div>
      <div class="admin_container">
        <div class="inventory-next_main">
          <div class="table_inventory_next_ft">
            <div>
              <div class="d-flex flex-wrap justify-end ma-n2 pb-4">
                <div class="pa-2">
                  <v-btn color="primary" @click="dialogAdd = true"
                    ><span class="mr-3 plus_icon_realization">+</span
                    >{{ $t("addRealizationProduct") }}
                  </v-btn>
                </div>
              </div>
              <div class="inventory_next_table">
                <table-with-filter
                  :options.sync="configuration.options"
                  hide-default-footer
                  :headers="filterableHeadersTable"
                  :items="items"
                  class="elevation-1 table_inv_next"
                >
                  <template #filter.id>
                    <div class="pa-1">
                      <custom-input-text
                        clearable
                        @input="getRealizationByFilter"
                        class="user_input no-margin"
                        v-model="realizationFilter.id"
                        type="text"
                      >
                      </custom-input-text>
                    </div>
                  </template>
                  <template #filter.contractNumber>
                    <div class="pa-1">
                      <custom-input-text
                        class="user_input no-margin"
                        type="text"
                        clearable
                        v-model="realizationFilter.contractNumber"
                        @input="getRealizationByFilter"
                      />
                    </div>
                  </template>
                  <template #filter.departmentName>
                    <div class="pa-1">
                      <custom-select
                        :items="departments"
                        clearable
                        v-model="realizationFilter.departmentId"
                        class="user_input no-margin"
                        @input="getRealizationByFilter"
                      />
                    </div>
                  </template>
                  <template #filter.productName>
                    <div class="pa-1">
                      <custom-select
                        :items="products"
                        clearable
                        class="user_input no-margin"
                        v-model="realizationFilter.productId"
                        @input="getRealizationByFilter"
                      />
                    </div>
                  </template>
                  <template #filter.realizatorFullName>
                    <div class="pa-1">
                      <custom-select
                        :items="implementator"
                        clearable
                        class="user_input no-margin"
                        @input="getRealizationByFilter"
                        :item-text="
                          (item) => `${item.firstName} ${item.middleName}`
                        "
                        v-model="realizationFilter.realizatorId"
                      >
                      </custom-select>
                    </div>
                  </template>
                  <template #filter.realizationDate>
                    <div class="pa-1 d-flex align-center">
                      <span
                        class="text--accent-1 mr-2 blue-dark--text flex-shrink-0"
                        >{{ $t("from") }}</span
                      >
                      <custom-date-picker
                        clearable
                        color="#E3EBF3"
                        :max="realizationFilter.toDate"
                        v-model="realizationFilter.fromDate"
                        @input="getRealizationByFilter"
                        class="mr-2 data_item data_item_calendar user_input"
                        icon="mdi-calendar-month small"
                      ></custom-date-picker>
                      <span
                        class="text--accent-1 mr-2 blue-dark--text flex-shrink-0"
                        >{{ $t("to") }}</span
                      >
                      <custom-date-picker
                        @input="getRealizationByFilter"
                        :min="realizationFilter.fromDate"
                        clearable
                        v-model="realizationFilter.toDate"
                        color="#E3EBF3"
                        class="data_input_tw ml-2 data_item user_input"
                        icon="mdi-calendar-month small"
                      ></custom-date-picker>
                    </div>
                  </template>

                  <template #item.realizationDate="{ item }">
                    {{ item.realizationDate | dateParse }}
                  </template>
                  <template #item.count="{ item }">{{
                    item.count | numberParse
                  }}</template>
                  <template #item.contractBalance="{ item }">{{
                    item.contractBalance | numberParse
                  }}</template>
                  <template #item.productAttrs="{ item }">
                    {{ item.productAttrs.join(" || ") }}
                  </template>
                </table-with-filter>
              </div>
              <vue-pagination
                @update:limit="
                  (limit) => {
                    configuration.pagination.limit = limit;
                    configuration.pagination.page = 1;
                    changePage();
                  }
                "
                v-model="configuration.pagination.page"
                :length="lastPage"
                @input="changePage"
                go-to
                :limit="configuration.pagination.limit"
              />

              <v-dialog
                v-model="dialogAdd"
                max-width="528px"
                class="user_modal_dialog"
              >
                <validation-observer
                  ref="realizationFormObs"
                  v-slot="{ handleSubmit }"
                >
                  <form @submit.prevent="handleSubmit(save)">
                    <v-card>
                      <v-card-title class="mb-4 justify-space-between">
                        <p class="mb-0">{{ $t("addRealizationProduct") }}</p>
                        <v-icon @click="dialogAdd = false">mdi-close</v-icon>
                      </v-card-title>
                      <v-card-text class="main_modal">
                        <v-container class="pa-0 user_modal_form">
                          <div class="row">
                            <div
                              class="col-lg-6 pt-lg-4 pt-0 pb-0 medium_15_01456A"
                            >
                              {{ $t("contractNumber") }}*
                            </div>
                            <search-input
                              item-value="contractNumber"
                              v-model="editedItem.contractNumber"
                              :items="outGoingContracts"
                              :name="$t('nContract')"
                              rules="required"
                              item-text="contractNumber"
                              class="col-lg-6 pt-0 user_input"
                              :placeholder="$t('nContract')"
                            ></search-input>
                          </div>
                          <div class="row">
                            <div
                              class="col-lg-6 pt-lg-4 pt-0 pb-0 medium_15_01456A"
                            >
                              {{ $t("department") }}
                            </div>
                            <custom-select
                              clearable
                              rules="required"
                              :items="departments"
                              class="col-lg-6 pt-0 user_input"
                              @input="changeDepartment"
                              v-model="editedItem.departmentId"
                              :placeholder="$t('department')"
                              :name="$t('department')"
                            ></custom-select>
                          </div>
                          <div class="row">
                            <div
                              class="col-lg-6 pt-lg-4 pt-0 pb-0 medium_15_01456A"
                            >
                              {{ $t("count") }}*
                            </div>
                            <number-input
                              rules="required"
                              v-model="editedItem.count"
                              class="col-lg-6 pt-0 user_input"
                              :placeholder="$t('count')"
                              :name="$t('count')"
                            ></number-input>
                          </div>
                          <div class="row">
                            <div
                              class="col-lg-6 pt-lg-4 pt-0 pb-0 medium_15_01456A"
                            >
                              {{ $t("implementDate") }}*
                            </div>
                            <custom-date-picker
                              :min="moment().format('YYYY-01-01')"
                              :max="moment().format('YYYY-12-12')"
                              :name="$t('implementDate')"
                              rules="required"
                              v-model="editedItem.realizationDate"
                              class="col-lg-6 pt-0 user_input"
                            ></custom-date-picker>
                          </div>
                        </v-container>
                      </v-card-text>
                      <v-card-actions class="footer_modal_user">
                        <div class="row">
                          <div
                            class="d-flex flex-wrap justify-space-around button_modal_add mr-1 mt-5 mb-2"
                          >
                            <v-btn color="primary" type="submit">{{
                              $t("save")
                            }}</v-btn>
                          </div>
                        </div>
                      </v-card-actions>
                    </v-card>
                  </form>
                </validation-observer>
              </v-dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce, makerPagination } from "@/utils/pureFunctions";
import SearchInput from "@/plugins/Vuetify/components/SearchInput";
import moment from "moment";
import NumberInput from "@/plugins/Vuetify/components/NumberInput";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";

export default {
  name: "realization-index",
  components: {
    VuePagination,
    TableWithFilter,
    NumberInput,
    SearchInput,
  },
  data() {
    return {
      moment,
      isShowFilter: false,
      ready: false,
      dialogAdd: false,
      visibleHeaders: [
        "id",
        "contractNumber",
        "departmentName",
        "realizatorFullName",
        "productName",
        "productAttrs",
        "count",
        "contractBalance",
        "unitType",
        "realizationDate",
      ],
      implementator: [],
      items: [],
      departments: [],
      products: [],
      outGoingContracts: [],
      editedItem: {
        contractNumber: null,
        realizationDate: null,
        count: null,
        departmentId: null,
      },
      lastPage: 0,
      configuration: {
        pagination: {
          page: 1,
          limit: 10,
        },
        options: {
          page: 1,
          sortBy: ["id"],
          sortDesc: [false],
          groupBy: [],
          groupDesc: [],
          mustSort: false,
          multiSort: false,
        },
      },
      realizationFilter: {
        contractNumber: null,
        numb: null,
        department: null,
        name: null,
        implementator: null,
        fromDate: null,
        toDate: null,
      },
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("number"), value: "id" },
        { text: this.$t("contractNumber"), value: "contractNumber" },
        { text: this.$t("sendDepartmentName"), value: "departmentName" },
        { text: this.$t("whoImplemented"), value: "realizatorFullName" },
        { text: this.$t("product"), value: "productName" },
        { text: this.$t("attributes"), value: "productAttrs" },
        { text: this.$t("count"), value: "count" },
        { text: this.$t("remainingContract"), value: "contractBalance" },
        { text: this.$t("countShort"), value: "uniType" },
        { text: this.$t("implementDate"), value: "realizationDate" },
      ];
    },
    filterableHeadersTable() {
      return this.headers.filter((item) => {
        return this.visibleHeaders.includes(item.value);
      });
    },
  },
  methods: {
    async getNotCompletedOutGoingContracts() {
      try {
        this.outGoingContracts = await this.$store.dispatch(
          "getOutgoingContracts",
          {
            isNotCompleted: true,
          }
        );
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    getRealizationByFilter: debounce(async function () {
      if (this.ready) {
        this.showLoading();
        const { page } = this.configuration.pagination;
        if (page !== 1) {
          this.configuration.pagination.page = 1;
          await this.$router.replace({ query: { page: `${page}` } });
        }
        await this.getRealizations();
        this.clearLoading();
      }
    }, 500),
    async changeDepartment(id) {
      this.editedItem.realizatorId = null;
      const {
        data: { data },
      } = await this.$store.dispatch("getUsers", {
        isDepartment: true,
        departmentId: id,
      });
      this.implementator = data;
    },
    async changePage(value) {
      const { page: queryPage } = this.$route.query;
      if (queryPage !== value.toString()) {
        this.showLoading();
        await this.$router.push({ query: { page: value.toString() } });
        this.configuration.pagination.page = value;
        await this.getRealizations();
        this.clearLoading();
      }
    },
    clearForm() {
      this.editedItem = {
        contractNumber: null,
        realizationDate: null,
        count: null,
        departmentId: null,
      };
      const { realizationFormObs } = this.$refs;
      if (realizationFormObs) realizationFormObs.reset();
    },
    async save() {
      this.showLoading();
      try {
        const formData = new FormData();
        const { contractNumber, departmentId, realizationDate, count } =
          this.editedItem;
        formData.append("contractNumber", contractNumber);
        formData.append("realizationDate", realizationDate);
        formData.append("departmentId", departmentId);
        formData.append("count", count.replace(",", ".").replace(/\s/g, ""));
        await this.$http.post("realization/save", formData);
        await this.getRealizations();
        await this.getNotCompletedOutGoingContracts();
        this.dialogAdd = false;
        this.clearForm();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async getRealizations() {
      const { page, limit } = this.configuration.pagination;
      let params = {
        ...this.realizationFilter,
        page: page - 1,
        limit,
      };
      try {
        const {
          data: { data, total },
        } = await this.$http.get("realization/list", {
          params,
        });
        this.items = data;
        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
  watch: {
    dialogAdd(val) {
      if (!val) {
        this.clearForm();
      }
    },
  },
  async mounted() {
    const { page } = this.$route.query;
    if (page) this.configuration.pagination.page = +page;
    this.showLoading();
    await this.getRealizations();
    this.ready = true;
    this.clearLoading();
    Promise.allSettled([
      this.$store.dispatch("getProducts"),
      this.$store.dispatch("getUsers", {
        isDepartment: true,
      }),
      this.$store.dispatch("getDepartments"),
      this.getNotCompletedOutGoingContracts(),
    ]).then(([products, users, departments]) => {
      if (products.value) this.products = products.value.data;
      if (users.value) this.implementator = users.value.data;
      if (departments.value) this.departments = departments.value.data;
    });
  },
};
</script>

<style scoped></style>
